import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CursorPaginationProps {
  total: number;
  page: number;
  limit: number;
  hasNext: boolean;
  hasPrev: boolean;
  onNext: () => void;
  onPrev: () => void;
  loading?: boolean;
  itemLabel?: string;
  className?: string;
}

export function CursorPagination({
  total,
  page,
  limit,
  hasNext,
  hasPrev,
  onNext,
  onPrev,
  loading = false,
  itemLabel = "items",
  className,
}: CursorPaginationProps) {
  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <div
      className={cn("flex flex-col items-center gap-3 sm:flex-row sm:justify-between", className)}
    >
      <p className="text-sm text-muted-foreground">
        {total === 0 ? (
          `No ${itemLabel}`
        ) : (
          <>
            Showing{" "}
            <span className="font-medium text-foreground">
              {start}&ndash;{end}
            </span>{" "}
            of <span className="font-medium text-foreground">{total}</span> {itemLabel}
          </>
        )}
      </p>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={onPrev} disabled={!hasPrev || loading}>
          <ChevronLeftIcon />
          Previous
        </Button>
        <Button variant="outline" size="sm" onClick={onNext} disabled={!hasNext || loading}>
          Next
          <ChevronRightIcon />
        </Button>
      </div>
    </div>
  );
}
